import { validateText } from './validate/validateText'
import { ref, getCurrentInstance, computed } from 'vue'
import { validateCombobox } from './validate/validateCombobox'
import i18nValidate from '@/i18ns/vi/i18nValidate'

export const useValidateControl = ({ props }) => {
  const errorMessage = ref('')
  const isValidate = computed(() => props.rules.length > 0)
  const { proxy } = getCurrentInstance()
  const ValidateRule = proxy.$ms.constant.ValidateRule

  /**
   * Có bắt buộc không
   */
  const isRequired = computed(() => {
    return typeof props.rules?.some === 'function' && props.rules.some(rule => rule.name === ValidateRule.Required)
  })

  /**
   * @description Hàm xử lý validate
   * @returns error message
   */
  const validate = () => {
    // Nếu là editor của grid thì sẽ lấy config từ column
    const rules = proxy._isGridEditor ? props.col.rules : props.rules
    let message = ''

    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]

        if (!rule) {
          continue
        }
        const { name, compareValue, customValidate } = rule
        const controlValue = getValueControl()
        // Nếu có custom validate sẽ lấy theo custom validate
        if (typeof customValidate === 'function') {
          message = customValidate(
            controlValue,
            compareValue,
            getTitleError()
          )
        } else {
          message = handlerRule(name, controlValue, compareValue)
        }
        if (message) {
          break
        }
      }
    }
    errorMessage.value = message
    return message
  }
  /**
   * Xử lý các rule validate
   * @param {*} rule tên rule
   * @param {*} compareValue value
   * @returns
   */
  const handlerRule = (rule, controlValue, compareValue) => {
    let message = ''
    const titleError = getTitleError()

    switch (rule) {
      case ValidateRule.Required:
        if (!validateRequired(controlValue)) {
          message = i18nValidate.messages[rule](titleError, proxy._isGridEditor)
        }
        break
      case ValidateRule.Pattern:
        if (!validateText.validateRule(compareValue, controlValue)) {
          message = i18nValidate.messages.email(titleError)
        }
        break
      default:
        break
    }
    return message
  }

  /**
   * Xử lý validate riêng cho combobox
   */
  const handlerValidateCombobox = () => {
    const { rules } = props
    let message = ''
    if (Array.isArray(rules) && rules.length > 0) {
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        if (rule) {
          // eslint-disable-next-line no-unused-vars
          const { name, compareValue, customValidate } = rule
          message = validateCombobox.validateRule(name, proxy)
          if (message) {
            break
          }
        }
      }
    }

    errorMessage.value = message

    return message
  }

  const validateRequired = (value) => {
    return !(!value ||
      Number.isNaN(value) ||
      (value instanceof Date && value.getTime() < 0) ||
      (typeof (controlValue) === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0))
  }

  const clearValidate = () => {
    errorMessage.value = ''
  }
  /**
   * Lấy value của control (Các control override hàm này)
   * @returns
   */
  const getValueControl = () => {
    return proxy.getValue()
  }

  /**
   * Lấy title của error
   * @returns
   */
  const getTitleError = () => {
    const { title } = props

    if (proxy._isGridEditor) {
      return props.col.caption
    }
    return title || getValidateName()
  }

  /**
   * Nếu control không khai báo name để hiển thị thông tin lỗi validate -> up parent find label
   */
  const getValidateName = () => {
    const fn = function (el, c) {
      if (!el || c > 10) {
        return null
      }

      const labelEl = el.querySelector('label')
      if (labelEl) {
        return (labelEl.innerText || '').replace('*', '')
      }

      return fn(el.parentNode, c + 1)
    }

    return fn(proxy.$el, 0)
  }

  return {
    errorMessage,
    validate,
    handlerValidateCombobox,
    getTitleError,
    clearValidate,
    isValidate,
    isRequired,
  }
}
